import { Empty } from 'antd';
import React from 'react';

export default function EmptyData() {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
}
